import * as types from '../actions/actionTypes';

const initialState = {
  selectionOpened: false,
  selectionGroup: "",
  activePartRelatedItemIndex: 0,
  selectionWindowView: 3,
  selectionInfoQuantity: 1,
  pulseFeatureInfoQuantity: false,
  pulseFeatureInfoNote: false,
  materialsInfoFeatureModules: [],  // arrayOf {partId: 123, quantity: 1}
  selectionFeatureInfo: null,
  activeFeature: null,
  // the feature the user clicked to open the SQFT calculator (row item / feature info screen / cart item).
  // answers only "what did the user pick" - unlike activeFeature, which is the feature applied to the
  // visualizer layout and may stay on the old material for price-level features (QCDES-8812).
  // not to be confused with sqftState.sqftFromFeature - see useUpdateEditedFeatures.js
  sqftOpenedFromFeature: null,
  updateFeatureCount: 0,  // counter - is used for update footer items
  relatedGroups: [],
  relatedGroupsSearch: "",
  showDescriptionCover: true,
  galleryVisible: false,
  galleryShowActiveFeature: false, // show related product gallery
  galleryActiveImageIndex: 0,
  subSteps: {
    edges: [],
    backsplashes: [],
  },
  activeSubStep: 0,
  showNotCompatibleView: false,
  productNoteEditorVisible: false,
  rowItems: [],
  materialsCanvasClass: "",
  featureInfoCount: 0, // is used to update feature info page
  materialsCanvasLoading: false, // is used to update loader
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_SELECTION_WINDOW:
    case types.SET_SELECTION_WINDOW_VIEW:
    case types.TOGGLE_SELECTION_INFO:
    case types.CHANGE_SELECTION_INFO_QUANTITY:
    case types.TOGGLE_PULSE_FEATURE_INFO_QUANTITY:
    case types.TOGGLE_PULSE_FEATURE_INFO_NOTE:
    case types.CHANGE_MATERIALS_INFO_FEATURE_MODULES:
    case types.SET_DEFAULT_SELECTION_GROUP:
    case types.CHANGE_SELECTION_ACTIVE_PART_RELATED_INDEX:
    case types.SET_RELATED_GROUPS_SEARCH:
    case types.TOGGLE_SHOW_DESCRIPTION_COVER:
    case types.TOGGLE_GALLERY_VISIBLE:
    case types.SET_GALLERY_ACTIVE_IMAGE_INDEX:
    case types.SET_MATERIALS_PAGE_ACTIVE_SUB_STEP:
    case types.TOGGLE_NOT_COMPATIBLE_VIEW:
    case types.TOGGLE_PRODUCT_NOTE_EDITOR_VISIBLE:
    case types.SET_ROW_ITEMS:
    case types.SET_MATERIALS_PAGE_CANVAS_CLASS:
    case types.SET_MATERIALS_PAGE_CANVAS_LOADING:
    case types.SET_SQFT_OPENED_FROM_FEATURE:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SQT_SQFT_FROM_FEATURE:
      // sqft calculator is closed - forget the feature it was opened from
      return action.payload.sqftFromFeature || !state.sqftOpenedFromFeature
        ? state
        : Object.assign({}, state, {sqftOpenedFromFeature: null});
    case types.SET_RELATED_GROUPS:
      return Object.assign({}, state, {
        relatedGroups: [...action.payload.relatedGroups]
      });
    case types.SET_MATERIALS_PAGE_SUB_STEPS:
      state = {...state, subSteps: Object.assign({}, state.subSteps, action.payload.subSteps)};
      break;
    case types.SET_ACTIVE_FEATURE:
      return Object.assign({}, state, {
        activeFeature: action.payload.activeFeature || null,
        updateFeatureCount: ++state.updateFeatureCount
      });
    case types.UPDATE_FEATURE_INFO_COUNT:
      return Object.assign({}, state, {
        featureInfoCount: ++state.featureInfoCount
      });

  }

  return state;

}
